export default {
    template: [
        'VFAIRUSER_TEMPLATE',
        data => ({
            id: data.vfairId,
            vfairId: data.vfairId,
            userId: data.userId,
            interested: data.interested,
        }),
    ],
    '/user': {
        '/me': {
            authorize: true,
            template: [
                'VFAIRUSER_TEMPLATE',
                data => ({
                    id: data.vfairId,
                    vfairId: data.vfairId,
                    userId: data.userId,
                    interested: data.interested,
                }),
            ],
            GET: {},
            '/:vfair_id': {
                authorize: true,
                template: [
                    'VFAIRUSER_TEMPLATE',
                    data => ({
                        id: data.vfairId,
                        vfairId: data.vfairId,
                        userId: data.userId,
                        interested: data.interested,
                    }),
                ],
                GET: {},
                POST: {},
                PUT: {},
            },
        },
    },
};
